// Actions related to API calls for acquisition
import { serverURL } from "../../constants/constants";
import axios from "axios";
import { batch } from "react-redux";
import { v4 } from "uuid";
// Imports for API CAlls
import {
  errorResponse,
  calculateShearWaveSpeed,
  setSampleValueDisplay,
  updateSamplesDoneFlag,
  setSampleProcessing,
  setAcquiring,
  checkNullSwsSelection,
  setSwsRange,
  updateSampleAlert,
  setBmodeThickness,
  calculateThickness,
  updateLocationWideRoiReference,
  getLocationZandDzValues,
  setBRange,
  createSample,
  receiveAcquisitionComplete,
  receiveSampleData,
  setSampleDataAvailable,
  setSampleDataSaved,
  updateSamplesSavedFlag,
} from "../../actions";

import {
  bmodeSampleFixture,
  stlSampleFixture,
  bmodeImages,
  swsValues,
  velocityImages,
  swsImages,
} from "../../constants/Fixtures/sampleFixture";

import { defaultPercentSliceWidth } from "../../constants/constants";

export const SET_SAMPLE_DATA = "SET_SAMPLE_DATA";
export function setSampleData(response) {
  return {
    type: SET_SAMPLE_DATA,
    id: response["uuid"],
    sampleType: response["type"],
    response,
  };
}

export const SET_SWS_PLOT = "SET_SWS_PLOT";
export function setSwsPlot(response, id) {
  return {
    type: SET_SWS_PLOT,
    id: id,
    response,
  };
}

export const SET_VELOCITY_SLICE_PLOT = "SET_VELOCITY_SLICE_PLOT";
export function setVelocitySlicePlot(response, id) {
  return {
    type: SET_VELOCITY_SLICE_PLOT,
    id: id,
    response,
  };
}

export const SET_BMODE_PLOT = "SET_BMODE_PLOT";
export function setBmodePlot(id, response, bmodeRange) {
  return {
    type: SET_BMODE_PLOT,
    id: id,
    response: response,
    bmodeRange: bmodeRange,
  };
}

export const SET_SWS_VALUE = "SET_SWS_VALUE";
export function setSwsValue(response, id) {
  return {
    type: SET_SWS_VALUE,
    id: id,
    sws: response,
  };
}

export function requestButtonPress() {
  return function (dispatch, getState) {
    let sample_uuid = v4();
    dispatch(setAcquiring(true));
    dispatch(createSample(sample_uuid, getState().locations.currentAcqType));

    dispatch(
      receiveAcquisitionComplete({
        uuid: sample_uuid,
        type: getState().locations.currentAcqType,
      })
    );
    if (getState().locations.currentAcqType === "BMODE") {
      let bmodeSample = bmodeSampleFixture;
      bmodeSample.uuid = sample_uuid;
      dispatch(receiveSampleData(bmodeSample));
    } else {
      let stlSample = stlSampleFixture;
      stlSample.uuid = sample_uuid;
      dispatch(receiveSampleData(stlSample));
    }
    dispatch(setSampleDataAvailable(sample_uuid, true));

    dispatch(setSampleDataSaved(sample_uuid, true));
    dispatch(updateSamplesSavedFlag());

    // return axios.get(serverURL + "/get_displacement").then(
    //   (response) => console.log("button pressed"),
    //   (error) => dispatch(errorResponse(error))
    // );
  };
}

// The request
export function formatSampleReprocessRequest(state, id) {
  let sample = state.samples.byId[id];
  let roiDzInMeters = sample.roiDz / 1e3;
  let zValInMeter = sample.zValue / 1e3;
  let swsRange = [
    sample.swsPlot.colorBar.yAxis.range[0],
    sample.swsPlot.colorBar.yAxis.range[1],
  ];
  let bRange = [
    sample.swsPlot.colorBar.xAxis.range[0],
    sample.swsPlot.colorBar.xAxis.range[1],
  ];
  let vMax = null;

  let saveFolderpath;
  if (state.studyInfo.studySaved) {
    let pathArray = state.studyInfo.studySavePath.split("/");
    let folderpath = pathArray.splice(0, pathArray.length - 1).join("/");
    saveFolderpath = folderpath;
  } else {
    saveFolderpath = state.studyInfo.wipPath;
  }

  if (sample.type !== "SINGLE") {
    vMax = sample.velocitySlicePlot.colorBar.range[1];
  }

  return {
    uuid: id,
    sample_type: sample.type,
    zval: zValInMeter,
    dz: roiDzInMeters,
    vmax: vMax,
    sws_range: swsRange,
    b_range: bRange,
    save_folderpath: saveFolderpath,
    credential: {
      username: state.userInfo.username,
      password: state.userInfo.password,
    },
    encryption: state.studyInfo.encryption,
    protocolId: state.studyInfo.protocolId,
  };
}

// SWS color limit changed => get new plots and new sws value
export function fetchSwsPlotAndVelocitySlicePlot(sampleId, swsRange) {
  return function (dispatch, getState) {
    batch(() => {
      dispatch(setSampleProcessing(sampleId, true));
      dispatch(setSampleValueDisplay(sampleId, false));
      dispatch(setSwsRange(sampleId, swsRange));
    });
    dispatch(updateSamplesDoneFlag());
    let state = getState();
    let sampleType = state.samples.byId[sampleId].type;

    let req = formatSampleReprocessRequest(state, sampleId);
    console.log(
      "GET request made for /get_sws_plot_and_velocity_slice_plot",
      req
    );
    return axios
      .post(serverURL + "/get_sws_plot_and_velocity_slice_plot", req)
      .then(
        (response) => {
          batch(() => {
            console.log("/get_sws_plot_and_velocity_slice_plot", response);
            dispatch(setSampleProcessing(sampleId, false));
            dispatch(setSampleValueDisplay(sampleId, true));
            dispatch(
              checkNullSwsSelection(sampleId, response.data["sws_value"])
            );
            dispatch(setSwsValue(response.data["sws_value"], sampleId));
            dispatch(setSwsPlot(response.data["sws_plot"], sampleId));
            if (sampleType !== "SINGLE") {
              dispatch(
                setVelocitySlicePlot(
                  response.data["velocity_slice_plot"],
                  sampleId
                )
              );
            }
          });
          dispatch(updateSamplesDoneFlag());
          dispatch(updateSampleAlert(sampleId, response.data["alert"]));
          dispatch(calculateShearWaveSpeed(sampleId));
        },
        (error) => {
          batch(() => {
            dispatch(setSampleProcessing(sampleId, false));
            dispatch(setSampleValueDisplay(sampleId, true));
            dispatch(errorResponse(error));
          });
          dispatch(updateSamplesDoneFlag());
        }
      );
  };
}

// ROI position changed (z, or dz changed) OR Vmax value changed
export function fetchSwsValueAndVelocitySlicePlot(sampleId) {
  return function (dispatch, getState) {
    batch(() => {
      dispatch(setSampleProcessing(sampleId, true));
      dispatch(setSampleValueDisplay(sampleId, false));
    });
    dispatch(updateSamplesDoneFlag());
    let state = getState();
    let sampleType = state.samples.byId[sampleId].type;
    // let req = formatSampleReprocessRequest(state, sampleId);
    // console.log(
    //   "GET request made for /get_sws_value_and_velocity_slice_plot with",
    //   req
    // );

    // return axios
    //   .post(serverURL + "/get_sws_value_and_velocity_slice_plot", req)
    //   .then(
    //     (response) => {
    //       console.log("/get_sws_value_and_velocity_slice_plot", response);
    batch(() => {
      let velocityImageName =
        "STL_velocity_" +
        Math.abs(
          state.samples.byId[sampleId].velocitySlicePlot.colorBar.range[1]
        ).toString();
      console.log(velocityImageName);

      let response = {
        image: velocityImages[velocityImageName],
        peak_data: [
          ...swsValues[state.samples.byId[sampleId].percentSliceWidth].peakData,
        ],
        color_bar: {
          ...state.samples.byId[sampleId].velocitySlicePlot.colorBar,
        },
        x_axis: { ...state.samples.byId[sampleId].velocitySlicePlot.xAxis },
        y_axis: { ...state.samples.byId[sampleId].velocitySlicePlot.yAxis },
        sws: swsValues[state.samples.byId[sampleId].percentSliceWidth].sws,
      };

      dispatch(checkNullSwsSelection(sampleId, response.sws));
      dispatch(setSwsValue(response.sws, sampleId));
      if (sampleType !== "SINGLE") {
        dispatch(setVelocitySlicePlot(response, sampleId));
      }
      dispatch(setSampleProcessing(sampleId, false));
      dispatch(setSampleValueDisplay(sampleId, true));
    });
    dispatch(updateSamplesDoneFlag());
    // dispatch(updateSampleAlert(sampleId, response.data["alert"]));
    // dispatch(calculateShearWaveSpeed(sampleId));
    //     },
    //     (error) => {
    //       batch(() => {
    //         dispatch(setSampleProcessing(sampleId, false));
    //         dispatch(setSampleValueDisplay(sampleId, true));
    //         dispatch(errorResponse(error));
    //       });
    //       dispatch(updateSamplesDoneFlag());
    //     }
    //   );
  };
}

export function fetchSwsPlot(sampleId, bRange) {
  return function (dispatch, getState) {
    batch(() => {
      dispatch(setSampleProcessing(sampleId, true));
      dispatch(setBRange(sampleId, bRange));
    });
    dispatch(updateSamplesDoneFlag());
    // let req = formatSampleReprocessRequest(getState(), sampleId);
    // console.log("GET request made for /get_sws_plot with:", req);
    // return axios.post(serverURL + "/get_sws_plot", req).then(
    //   (response) => {
    //     console.log("/get_sws_plot", response);
    let state = getState();
    batch(() => {
      let swsImageName =
        "STL_sws_" +
        Math.abs(bRange[0]).toString() +
        "_" +
        Math.abs(bRange[1]).toString();
      console.log(swsImageName);

      let response = {
        image: swsImages[swsImageName],
        color_bar: {
          x_axis: {
            range: bRange,
            unit: state.samples.byId[sampleId].swsPlot.colorBar.yAxis.unit,
            label: state.samples.byId[sampleId].swsPlot.colorBar.xAxis.label,
          },
          y_axis: { ...state.samples.byId[sampleId].swsPlot.colorBar.yAxis },
        },
      };

      dispatch(setSwsPlot(response, sampleId));
      dispatch(setSampleProcessing(sampleId, false));
    });
    dispatch(updateSamplesDoneFlag());
    // dispatch(updateSampleAlert(sampleId, response.data["alert"]));
    //   },
    //   (error) => {
    //     dispatch(setSampleProcessing(sampleId, false));
    //     dispatch(updateSamplesDoneFlag());
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

export function fetchBmodePlot(sampleId, bmodeRange) {
  return function (dispatch, getState) {
    dispatch(setSampleProcessing(sampleId, true));
    dispatch(setSampleValueDisplay(sampleId, false));
    dispatch(updateSamplesDoneFlag());
    let state = getState();
    // let sample = state.samples.byId[sampleId];
    // let saveFolderpath;
    // if (state.studyInfo.studySaved) {
    //   let pathArray = state.studyInfo.studySavePath.split("/");
    //   let folderpath = pathArray.splice(0, pathArray.length - 1).join("/");
    //   saveFolderpath = folderpath;
    // } else {
    //   saveFolderpath = state.studyInfo.wipPath;
    // }

    // let req = {
    //   uuid: sampleId,
    //   bmode_range: bmodeRange,
    //   save_folderpath: saveFolderpath,
    //   credential: {
    //     username: state.userInfo.username,
    //     password: state.userInfo.password,
    //   },
    //   encryption: state.studyInfo.encryption,
    //   protocolId: state.studyInfo.protocolId,
    // };
    // console.log("GET request made for /get_bmode_plot with", req);
    // return axios.post(serverURL + "/get_bmode_plot", req).then(
    //   (response) => {
    batch(() => {
      let bmodeImageName =
        "bmode_" +
        Math.abs(bmodeRange[0]).toString() +
        "_" +
        Math.abs(bmodeRange[1]).toString();
      console.log(bmodeImageName);
      let response = {
        image_data: bmodeImages[bmodeImageName],
        top_avg: state.samples.byId[sampleId].autoDetectedTopSurface,
        bottom_avg: state.samples.byId[sampleId].autoDetectedBottomSurface,
      };

      dispatch(setBmodePlot(sampleId, response, bmodeRange));
      dispatch(setSampleProcessing(sampleId, false));
      dispatch(setSampleValueDisplay(sampleId, true));
      // dispatch(
      //   setBmodeThickness(
      //     response.data.top_avg,
      //     response.data.bottom_avg,
      //     sampleId
      //   )
      // );
    });

    dispatch(updateSamplesDoneFlag());
    // dispatch(updateSampleAlert(sampleId, response.data["alert"]));

    //     if (sample.setToAutoDetectedThickness) {
    //       if (
    //         state.locations.byId[sample.locationId].roiReference.locationWide
    //           .id === sampleId
    //       ) {
    //         dispatch(updateLocationWideRoiReference(null, sample.locationId));
    //       } else if (
    //         state.locations.byId[sample.locationId].roiReference.default ===
    //         sampleId
    //       ) {
    //         dispatch(
    //           fetchSetDz(
    //             Math.abs(response.data.bottom_avg - response.data.top_avg) *
    //               (defaultPercentSliceWidth / 100),
    //             Number(
    //               (
    //                 (response.data.top_avg + response.data.bottom_avg) /
    //                 2
    //               ).toFixed(5)
    //             )
    //           )
    //         );
    //       }

    //       dispatch(calculateThickness(sampleId));
    //     }
    //   },
    //   (error) => {
    //     dispatch(setSampleProcessing(sampleId, false));
    //     dispatch(setSampleValueDisplay(sampleId, true));
    //     dispatch(updateSamplesDoneFlag());
    //     dispatch(errorResponse(error));
    //   }
    // );
  };
}

//Set new default dz on server
export function fetchSetDz(dz, z) {
  return function (dispatch) {
    let dzInMeters;
    let zInMeters;
    if (dz === 0 || dz === null) {
      dzInMeters = null;
    } else {
      dzInMeters = dz / 1e3;
    }

    if (z === 0 || z === null) {
      zInMeters = null;
    } else {
      zInMeters = z / 1e3;
    }
    console.log(
      "POST request made for /set_dz with dz:",
      dzInMeters,
      "z:",
      zInMeters
    );
    // return axios
    //   .post(serverURL + "/set_dz", {
    //     dz: dzInMeters,
    //     z_val: zInMeters,
    //   })
    //   .then(() => (error) => dispatch(errorResponse(error)));
  };
}

export function fetchUploadRawSampleData(dataFilePath) {
  return function (dispatch, getState) {
    let state = getState();
    let location = state.locations.byId[state.locations.selectedLocationId];
    let saveFolderpath;
    if (state.studyInfo.studySaved) {
      let pathArray = state.studyInfo.studySavePath.split("/");
      let folderpath = pathArray.splice(0, pathArray.length - 1).join("/");
      saveFolderpath = folderpath;
    } else {
      saveFolderpath = state.studyInfo.wipPath;
    }
    let sws_range = null;
    if (Object.keys(state.protocol).includes("sws_range")) {
      sws_range = [state.protocol.sws_range[0], state.protocol.sws_range[1]];
    }

    let locationROI = getLocationZandDzValues(state);

    let req = {
      dataFilePath: dataFilePath,
      save_folderpath: saveFolderpath,
      credential: {
        username: state.userInfo.username,
        password: state.userInfo.password,
      },
      encryption: state.studyInfo.encryption,
      protocolId: state.studyInfo.protocolId,
      studyId: state.studyInfo.id,
      participantId: state.studyInfo.participantId,
      locationId: location.id,
      sws_range: sws_range,
      dz: locationROI.dz,
      z_val: locationROI.z,
    };
    console.log("GET request made for /upload_raw_sample_data with ", req);
    return axios.post(serverURL + "/upload_raw_sample_data", req).then(
      (response) => {
        // console.log(response);
      },
      (error) => dispatch(errorResponse(error))
    );
  };
}
